import React, { FC, useEffect } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Navigation } from '@ucheba/ui/components/Navigation/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IStudyOptions } from '../types'
import StudyOptionsCourses from './StudyOptionsCourses'
import StudyOptionsDefault from './StudyOptionsDefault'
import { useStudyOptions } from '../bll'

const StudyOptions: FC<IStudyOptions> = (props) => {
  const { list, isCourses, setBaseEducationType, programType } = props

  const { items, onClick, activeIndex, title, filteredList } = useStudyOptions(
    list,
    programType
  )

  useEffect(() => {
    if (items && items[0]) {
      setBaseEducationType({
        id: Number(items[0].slug),
        name: items[0].name,
      })
    }
  }, [items])

  return (
    <div>
      <Heading h3={title} spacing='medium' />

      {items && items.length > 1 && (
        <>
          <Navigation items={items} activeIndex={activeIndex} onClick={onClick} />

          <Spacing spacing='large' />
        </>
      )}

      {isCourses ? (
        <StudyOptionsCourses list={filteredList} />
      ) : (
        <StudyOptionsDefault list={filteredList} />
      )}
    </div>
  )
}

export default StudyOptions
